(() => {
  if (window.dorelanNewsletter) return;
  const key = 'dorelan:newsletter-signup';
  const registered = new WeakSet();

  function remember(form) {
    const email = form.querySelector('[name="contact[email]"]');
    const tags = form.querySelector('[name="contact[tags]"]')?.value || '';
    if (!email || !/newsletter/i.test(tags) || !form.checkValidity()) return;
    try {
      sessionStorage.setItem(key, JSON.stringify({
        formId: form.id,
        email: email.value.trim(),
        detail: form.closest('[data-newsletter-detail]')?.dataset.newsletterDetail || 'general_page',
        timestamp: Date.now()
      }));
    } catch {
      return;
    }
  }

  function complete(form) {
    let pending;
    try {
      pending = JSON.parse(sessionStorage.getItem(key));
      if (!pending) return;
      if (!Number.isFinite(pending.timestamp) || Date.now() - pending.timestamp > 15 * 60 * 1000) {
        sessionStorage.removeItem(key);
        return;
      }
      const result = form.querySelector('[data-newsletter-result]')?.dataset.newsletterResult;
      if (form.id !== pending.formId || !['success', 'error'].includes(result)) return;
      sessionStorage.removeItem(key);
      if (result !== 'success' || typeof pending.email !== 'string' || typeof pending.detail !== 'string') return;
    } catch {
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ga4_event',
      event_name: 'newsletter_signup',
      event_detail: pending.detail,
      user_data: { email: pending.email }
    });
  }

  function register(form) {
    if (!form || registered.has(form)) return;
    registered.add(form);
    form.addEventListener('submit', () => remember(form));
    complete(form);
  }

  window.dorelanNewsletter = { remember, register };
  (window.dorelanNewsletterQueue || []).forEach(register);
  window.dorelanNewsletterQueue = [];
})();